// todo: improve accessibility, fix cursor on hover
import type { ChangeEvent, FC, MouseEvent, ReactElement } from 'react'

import type { WhiteLabel } from '@skytech/types'

import { ErrorMessage } from '../ErrorMessage'
import { Label } from '../Label'

import './styles.scss'

export const Radio: FC<{
  id: string
  checked?: boolean
  label?: string | ReactElement
  capitalizeLabel?: boolean
  marginBottom?: number
  name?: string
  className?: string
  value?: string
  customValue?: string
  error?: string | ReactElement
  touched?: boolean
  isDisabled?: boolean
  onChange?: (e: ChangeEvent<HTMLInputElement>) => void
  onFieldChange?: () => void
  onClick?: (e: MouseEvent<HTMLInputElement>) => void
}> = ({
  id,
  label,
  marginBottom,
  value,
  capitalizeLabel,
  checked,
  isDisabled,
  error,
  touched,
  customValue,
  className = '',
  onChange,
  onFieldChange,
  onClick,
  ...rest
}) => {
  // todo: replace with the org from url when ready
  const whiteLabel = localStorage.getItem('org') as WhiteLabel

  const isChecked = id === value || checked || false

  return (
    <span
      className={`ui-radio ${className} ${isChecked ? 'checked' : ''} ${
        isDisabled ? 'is-disabled' : ''
      } ${whiteLabel}`}
    >
      {label && (
        <Label marginBottom={0} capitalizeLabel={capitalizeLabel} htmlFor={id}>
          {label}
        </Label>
      )}

      <input
        id={id}
        type="radio"
        value={customValue || id}
        checked={isChecked}
        style={{ marginBottom: marginBottom || 0 }}
        disabled={isDisabled}
        onChange={e => {
          if (onChange) onChange(e)
          if (onFieldChange) onFieldChange()
        }}
        // to handle a case of deselecting radio in some cases
        onClick={e => {
          if (!isChecked || !onClick) return
          onClick(e)
        }}
        {...rest}
      />

      {error && touched && <ErrorMessage>{error}</ErrorMessage>}
    </span>
  )
}
